import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatText } from '../../../../helpers/value'
import {
  SCORE_TYPE,
  TABLE_FILTER_TITLE,
} from '../../../filteredCompanies/filteredCompany/constant'
import { CustomTdScore } from './CustomTdScore'
import { CustomTdStatus } from './CustomTdStatus'
import { CustomTdTitle } from './CustomTdTitle'
import { CustomThTitle } from './CustomThTitle'
import { CustomThTooltip } from './CustomThTooltip'

export const getSchemaTableFilteredCompany = () =>
  TABLE_FILTER_TITLE.map((item, index) => {
    const result = {
      title: <Translate value={item.label} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
        textTransform: 'capitalize',
      },
      tdStyle: {
        whiteSpace: 'nowrap',
      },
    }
    if (index === 0) {
      return {
        title: <CustomThTitle item={item.label} />,
        colId: item.key,
        tdStyle: {
          padding: 0,
        },
        render: (val, { rowId, locale }) => {
          return <CustomTdTitle val={val} rowId={rowId} />
        },
      }
    }
    if (index === 2) {
      return {
        ...result,
        render: (val) => {
          return <CustomTdStatus val={val} />
        },
      }
    }
    if (index === 3) {
      return {
        ...result,
        thStyle: {
          textAlign: 'center',
          whiteSpace: 'normal',
          justifyContent: 'center',
        },
        render: (val) => {
          return <CustomTdScore val={val} type={SCORE_TYPE.CREDIT_RISK} />
        },
      }
    }
    if (index === 4) {
      return {
        ...result,
        thStyle: {
          textAlign: 'center',
          whiteSpace: 'normal',
          justifyContent: 'center',
        },
        render: (val) => {
          return <CustomTdScore val={val} type={SCORE_TYPE.PERFORMANCE} />
        },
      }
    }
    if (index === 5) {
      return {
        ...result,
        title: <CustomThTooltip value={item.label} />,
        sortable: true,
        render: (val, { locale }) => {
          return formatDateTime(val, FORMAT.DATE, locale)
        },
      }
    }
    return {
      ...result,
      render: (val) => {
        return formatText(val)
      },
    }
  })
